import { render, staticRenderFns } from "./FormSetting_Staff.vue?vue&type=template&id=c3965fa6&scoped=true"
import script from "./FormSetting_Staff.vue?vue&type=script&lang=js"
export * from "./FormSetting_Staff.vue?vue&type=script&lang=js"
import style0 from "./FormSetting_Staff.vue?vue&type=style&index=0&id=c3965fa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3965fa6",
  null
  
)

export default component.exports